import React, { useEffect, useRef, useState } from "react";
import axiosInstance from "../../utils/axios";
import EntityManagement from "../../components/formTemplates/EntityManagement";
import EntityTable from "../../components/templateComponents/EntityTable";
import useDropdownFetch from "../../components/apiFetch/useDropdownFetch";

const Floors = () => {
  // States
  const [formData, setFormData] = useState({
    establishment_id: "",
    campusid: "",
    bldg_id: "",
    floor_ids: "",
    floor_no: "", 
    floor_name: "",
    status_id: "",
  });

  const [entities, setEntities] = useState([]);

  const [dropdownData, setDropdownData] = useState({
    establishment_id: [],
    campusid: [],
    bldg_id: [],
    floor_no: [],
    status_id: [],
  });

  const [editMode, setEditMode] = useState(false);
  const [editingEntityId, setEditingEntityId] = useState(null);
  const [isTableModalOpen, setIsTableModalOpen] = useState(false);
  const [selectedEstId, setSelectedEstId] = useState("");
  const [selectedCampusId, setSelectedCampusId] = useState("");
  const [selectedBldgId, setSelectedBldgId] = useState("");

  const firstFormFieldRef = useRef(null);


  const endpoints = {
    establishments: "/view_establishment/v1.1",
    campuses: "/view_campus/v1.1",
    buildings: "/view_building/v1.1",
    floors: "/view_floor/v1.1",
    registerFloor: "/registration_floor/v1.1",
    updateFloor: "/update_floor/v1.1",
    status: "/view_status/v0.1",
    floorTypes: "/view_bldg_flr_type/v1.1",
  };

 
  useEffect(() => {
    // Establishments
    axiosInstance
      .post(endpoints.establishments, { area_id: 1, view_type: "view" })
      .then((res) => {
        const formatted = Object.entries(res.data.Data || {}).map(([value, label]) => ({ value, label }));
        setDropdownData((prev) => ({ ...prev, establishment_id: formatted }));
      });

  
    axiosInstance
      .post(endpoints.floorTypes, { view_type: "view" })
      .then((res) => {
        const formatted = Object.entries(res.data.Data || {}).map(([value, label]) => ({ value, label }));
        setDropdownData((prev) => ({ ...prev, floor_no: formatted }));
      });

  }, []);


  const { options: statusOptions } = useDropdownFetch(endpoints.status);
  useEffect(() => {
    if (statusOptions) {
      setDropdownData((prev) => ({ ...prev, status_id: statusOptions }));
    }
  }, [statusOptions]);

  
  useEffect(() => {
    if (!formData.establishment_id) {
      setDropdownData((prev) => ({ ...prev, campusid: [] }));
      return;
    }
    axiosInstance
      .post(endpoints.campuses, { est_id: formData.establishment_id, view_type: "view" })
      .then((res) => {
        const formatted = Object.entries(res.data.Data || {}).map(([value, label]) => ({ value, label }));
        setDropdownData((prev) => ({ ...prev, campusid: formatted }));
      });
  }, [formData.establishment_id]);

  useEffect(() => {
    if (!formData.campusid) {
      setDropdownData((prev) => ({ ...prev, bldg_id: [] }));
      return;
    }
    axiosInstance
      .post(endpoints.buildings, { campusid: formData.campusid, view_type: "view" })
      .then((res) => {
        const formatted = Object.entries(res.data.Data || {}).map(([value, label]) => ({ value, label }));
        setDropdownData((prev) => ({ ...prev, bldg_id: formatted }));
      });
  }, [formData.campusid]);


  useEffect(() => {
    if (!selectedEstId) {
      setDropdownData((prev) => ({ ...prev, campusid: [] }));
      return;
    }
    axiosInstance
      .post(endpoints.campuses, { est_id: selectedEstId, view_type: "view" })
      .then((res) => {
        const formatted = Object.entries(res.data.Data || {}).map(([value, label]) => ({ value, label }));
        setDropdownData((prev) => ({ ...prev, campusid: formatted }));
      });
  }, [selectedEstId]);

  useEffect(() => {
    if (!selectedCampusId) {
      setDropdownData((prev) => ({ ...prev, bldg_id: [] }));
      return;
    }
    axiosInstance
      .post(endpoints.buildings, { campusid: selectedCampusId, view_type: "view" })
      .then((res) => {
        const formatted = Object.entries(res.data.Data || {}).map(([value, label]) => ({ value, label }));
        setDropdownData((prev) => ({ ...prev, bldg_id: formatted }));
      });
  }, [selectedCampusId]);

  
  useEffect(() => {
    if (isTableModalOpen && selectedBldgId) {
      fetchFloors(selectedBldgId);
    } else if (isTableModalOpen) {
      setEntities([]);
    }
  }, [selectedBldgId, isTableModalOpen]);

 
  const fetchFloors = async (bldgId) => {
    if (!bldgId) {
      setEntities([]);
      return;
    }
    try {
      const res = await axiosInstance.post(endpoints.floors, {
        view_type: "view all",
        bldg_id: parseInt(bldgId),
      });
      setEntities(Array.isArray(res.data?.Data) ? res.data.Data : []);
    } catch {
      setEntities([]);
    }
  };

  
  const handleViewTableClick = () => {
    if (!selectedEstId && formData.establishment_id) setSelectedEstId(formData.establishment_id);
    if (!selectedCampusId && formData.campusid) setSelectedCampusId(formData.campusid);
    if (!selectedBldgId && formData.bldg_id) setSelectedBldgId(formData.bldg_id);
    setIsTableModalOpen(true);
  };


  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      floor_ids: parseInt(formData.floor_ids),
      bldg_flr_typ_id: parseInt(formData.floor_no),
      bldg_id: parseInt(formData.bldg_id),
      bldg_floorname: formData.floor_name,
      status_id: parseInt(formData.status_id),
    };
    try {
      if (editMode) {
        await handleUpdate(editingEntityId, payload);
      } else {
        const res = await axiosInstance.post(endpoints.registerFloor, payload);
        if (res.data.Status === "Success") {
          await fetchFloors(selectedBldgId || formData.bldg_id);
          resetForm();
        }
      }
    } catch (error) {
      console.error("Error adding/updating floor:", error);
    }
  };

  const handleUpdate = async (id, payload) => {
    try {
      const res = await axiosInstance.post(endpoints.updateFloor, {
        ...payload,
        bldg_fid: id,
      });
      if (res.data.Status === "Success") {
        await fetchFloors(selectedBldgId || formData.bldg_id);
        resetForm();
        setIsTableModalOpen(false);
      }
    } catch (err) {
      console.error("Error updating floor:", err);
    }
  };

  
  const handleEdit = (id) => {
    const entity = entities.find((e) => e?.bldg_fid === id);
    if (entity) {
      setFormData({
        establishment_id: entity.establishment_id || "",
        campusid: entity.campusid || "",
        bldg_id: entity.bldg_id || "",
        floor_ids: entity.floor_ids || "",
        floor_no: entity.bldg_flr_typ_id || "",
        floor_name: entity.bldg_floorname || "",
        status_id: entity.status_id || "",
      });
      setEditMode(true);
      setEditingEntityId(id);
      setIsTableModalOpen(false);
    }
  };


 
  const resetForm = () => {
    setFormData({
      establishment_id: "",
      campusid: "",
      bldg_id: "",
      floor_ids: "",
      floor_no: "",
      floor_name: "",
      status_id: "",
    });
    setEditMode(false);
    setEditingEntityId(null);
  };


  const formFields = [
    { name: "floor_ids", label: "Floor ID", type: "text", readOnly: true },
    { name: "establishment_id", label: "Establishment", type: "select", dropdownKey: "establishment_id", required: true },
    { name: "campusid", label: "Campus", type: "select", dropdownKey: "campusid", required: true },
    { name: "bldg_id", label: "Building", type: "select", dropdownKey: "bldg_id", required: true },
    { name: "floor_no", label: "Floor Type", type: "select", dropdownKey: "floor_no", required: true },
    { name: "floor_name", label: "Floor Name", type: "text", required: true },
    { name: "status_id", label: "Status", type: "select", dropdownKey: "status_id", required: true },
  ];

  
  const columns = [
    { name: "bldg_fid", label: "Floor Record ID" },
    { name: "floor_ids", label: "Floor ID (Displayed)" },
    { name: "bldg_floorname", label: "Floor Name" },
    { name: "bldg_name", label: "Building" },
    { name: "status_name", label: "Status" },
  ];

  const dropdownStyle = {
    padding: "10px 14px",
    fontSize: "14px",
    border: "1px solid #d1d5db",
    borderRadius: "6px",
    width: "200px",
    backgroundColor: "#fff",
    color: "#111827",
    appearance: "none",
    backgroundSize: "1rem",
    cursor: "pointer",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
  };
  const labelStyle = {
    fontWeight: "600",
    marginBottom: "0.6rem",
    fontSize: "14px",
    color: "#374151",
  };

 
  const safeEntities = (entities || []).filter((item) => item && item.bldg_fid != null);


  return (
    <div className="floors">
      <EntityManagement
        entityName="Floor"
        formFields={formFields}
        formData={formData}
        setFormData={setFormData}
        handleFormSubmit={handleFormSubmit}
        dropdownData={dropdownData}
        setDropdownData={setDropdownData}
        firstFormFieldRef={firstFormFieldRef}
        handleViewTableClick={handleViewTableClick}
        onEdit={handleEdit}
      />

      {isTableModalOpen && (
        <div className="modal">
          <div className="modal-content" style={{ maxWidth: 900, margin: "auto" }}>
            <button onClick={() => setIsTableModalOpen(false)}>Close</button>

            {/* Filters */}
            <div
              style={{
                display: "flex",
                gap: "2rem",
                marginBottom: "1.5rem",
                backgroundColor: "#f9fafb",
                padding: "1rem",
                borderRadius: "8px",
                boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
                border: "1px solid #e5e7eb",
                justifyContent: "center",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label style={labelStyle}>Filter by Establishment:</label>
                <select
                  value={selectedEstId}
                  onChange={(e) => {
                    setSelectedEstId(e.target.value);
                    setSelectedCampusId("");
                    setSelectedBldgId("");
                  }}
                  style={dropdownStyle}
                >
                  <option value="">All</option>
                  {dropdownData.establishment_id.map(({ value, label }) => (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  ))}
                </select>
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <label style={labelStyle}>Filter by Campus:</label>
                <select
                  value={selectedCampusId}
                  onChange={(e) => {
                    setSelectedCampusId(e.target.value);
                    setSelectedBldgId("");
                  }}
                  style={dropdownStyle}
                >
                  <option value="">All</option>
                  {dropdownData.campusid.map(({ value, label }) => (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  ))}
                </select>
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <label style={labelStyle}>Filter by Building:</label>
                <select
                  value={selectedBldgId}
                  onChange={(e) => setSelectedBldgId(e.target.value)}
                  style={dropdownStyle}
                >
                  <option value="">All</option>
                  {dropdownData.bldg_id.map(({ value, label }) => (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <EntityTable
              data={safeEntities}
              columns={columns}
              onEdit={handleEdit}
              keyField="bldg_fid"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Floors;
